import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData, reqFormDataBanner } from "../../../js/server";
import { fnNotAdmin, cloneObj } from "../../../js/util";
import SubMenu from "../../comm/SubMenu";
import SubBanner from "../../comm/SubBanner";
import { CSSTransition, TransitionGroup } from "react-transition-group";

function BannerMgr({ props }) {
    const dispatch = useDispatch();
    const [userToken, setUserToken] = useState(null);
    const [bnUrl, setBnUrl] = useState("https://");
    const [selectedFile, setSelectedFile] = useState(null);
    const [banners, setBanners] = useState([]);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleBnUrlChange = (e) => {
        setBnUrl(e.target.value);
    };

    const fnSaveClick = () => {
        if (!selectedFile) {
            alert("배너이미지를 선택해 주세요.");
        } else {
            if (window.confirm("배너이미지를 저장하시겠습니까?")) {
                let formData = new FormData();
                formData.append("file", selectedFile, selectedFile.name);
                formData.append("servicename", "BannerSave");
                formData.append("userToken", userToken);
                formData.append("bn_url", bnUrl);

                dispatch({ type: "loadingChange", payload: true });
                reqFormDataBanner(formData)
                    .then((res) => {
                        const resData = res.data.jsonData;
                        let copiedObj = cloneObj(banners);
                        copiedObj.unshift(resData);
                        setBanners(copiedObj);
                        setSelectedFile(null);
                        setBnUrl("https://");
                        document.querySelector("#file").value = "";

                        alert("저장되었습니다.");
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        dispatch({ type: "loadingChange", payload: false });
                    });
            }
        }
    };

    const fetchData = () => {
        const jsonData = {
            servicename: "BannerList",
            userToken: userToken,
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    setBanners(res.data.jsonData);
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    const fnBnEditClick = (idx, serial, e) => {
        if (window.confirm("수정하시겠습니까?")) {
            let formData = new FormData();
            const objFile = document.querySelector("#file" + idx);
            const objUrl = document.querySelector("#bn_url" + idx);
            if (objFile.files[0]) {
                formData.append("file", objFile.files[0], objFile.files[0].name);
            }
            formData.append("servicename", "BannerSave");
            formData.append("userToken", userToken);
            formData.append("bn_url", objUrl.value);
            formData.append("bn_serial", serial);

            dispatch({ type: "loadingChange", payload: true });
            reqFormDataBanner(formData)
                .then((res) => {
                    const resData = res.data.jsonData;
                    let copiedObj = cloneObj(banners);
                    copiedObj[idx].bn_dir = resData.bn_dir;
                    copiedObj[idx].bn_filename = resData.bn_filename;
                    copiedObj[idx].bn_serial = resData.bn_serial;
                    copiedObj[idx].bn_url = resData.bn_url;
                    copiedObj[idx].file_url = resData.file_url;
                    copiedObj[idx].update_dt = resData.update_dt;
                    copiedObj[idx].wdate = resData.wdate;
                    setBanners(copiedObj);
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnBnDeleteClick = (idx, serial, e) => {
        if (window.confirm("삭제하시겠습니까?")) {
            const jsonData = {
                servicename: "BannerDelete",
                userToken: userToken,
                bn_serial: serial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        let copiedObj = cloneObj(banners);
                        var idx = copiedObj.findIndex((i) => i.bn_serial === serial);
                        if (idx > -1) copiedObj.splice(idx, 1);
                        setBanners(copiedObj);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    useEffect(
        () => {
            dispatch({
                type: "pageChange",
                payload: { sub01: "관리자메뉴", sub02: "배너관리" },
            });
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                //로그인 체크
                const userinfo = JSON.parse(localStorage.getItem("userinfo"));
                if (userinfo) {
                    const userToken = userinfo.userToken;
                    setUserToken(userToken);

                    //로그인 체크 후 Usertype 검사
                    LoginToken(userToken)
                        .then((res) => {
                            if (res.data.result === "OK") {
                                if (res.data.jsonData.usertype === "0") {
                                    fetchData();
                                } else {
                                    fnNotAdmin();
                                }
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            localStorage.removeItem("userinfo");

                            fnNotAdmin();
                        })
                        .finally(() => {
                            //dispatch({ type: 'loadingChange', payload: false })
                        });
                } else {
                    fnNotAdmin();
                }
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <SubBanner id="admin" />

            <section className="admin section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-12">
                                    <h2>배너관리</h2>
                                    <span>메인/사이드에 노출될 배너를 등록해 주세요.</span>
                                </div>
                            </div>

                            <div className="container pt-20 pb-20">
                                <div className="row round-box">
                                    <div className="col-12">
                                        <div className="row pb-10">
                                            <div className="col-12 mb-30">
                                                <h5 className="sub-title">신규추가</h5>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">
                                                        배너이미지 선택
                                                    </label>
                                                    <input
                                                        id="file"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">
                                                        목적지주소
                                                    </label>
                                                    <input
                                                        name="bn_url"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="100"
                                                        placeholder="https://"
                                                        value={bnUrl}
                                                        onChange={handleBnUrlChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 text-center">
                                                <span
                                                    className="btn btn-main btn-icon btn-round-full"
                                                    onClick={fnSaveClick}
                                                >
                                                    저장
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="container pb-20">
                                <div className="row round-box">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 mb-30">
                                                <h5 className="sub-title">등록배너</h5>
                                            </div>

                                            <TransitionGroup>
                                                {banners.map((banner, i) => {
                                                    return (
                                                        <CSSTransition
                                                            key={i}
                                                            timeout={700}
                                                            classNames="transition-item"
                                                        >
                                                            <div className="col-12 pb-20">
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="container p-0 m-0">
                                                                            <div className="row">
                                                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                                                    <div className="form-group">
                                                                                        <div className="form-group">
                                                                                            <label className="form-control-label">
                                                                                                배너이미지 선택
                                                                                            </label>
                                                                                            <input
                                                                                                id={`file${i}`}
                                                                                                name={`file${i}`}
                                                                                                type="file"
                                                                                                accept="image/*"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                                                    <div className="form-group">
                                                                                        <label className="form-control-label">
                                                                                            목적지주소
                                                                                        </label>
                                                                                        <input
                                                                                            id={`bn_url${i}`}
                                                                                            name={`bn_url${i}`}
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            maxLength="100"
                                                                                            placeholder="https://"
                                                                                            value={banner.bn_url || ""}
                                                                                            onChange={(e) => {
                                                                                                let copiedObj =
                                                                                                    cloneObj(banners);
                                                                                                copiedObj[i]["bn_url"] =
                                                                                                    e.target.value;
                                                                                                setBanners(copiedObj);
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 pb-3">
                                                                                    <img
                                                                                        src={banner.file_url || null}
                                                                                        className="client-thumb"
                                                                                        alt={banner.bn_filename || ""}
                                                                                    />
                                                                                    <br />
                                                                                </div>

                                                                                <div className="col-12 text-center">
                                                                                    <span
                                                                                        className="btn btn-main btn-icon btn-round-full"
                                                                                        onClick={(e) =>
                                                                                            fnBnEditClick(
                                                                                                i,
                                                                                                banner.bn_serial,
                                                                                                e
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        저장
                                                                                    </span>
                                                                                    &nbsp;&nbsp;
                                                                                    <span
                                                                                        className="btn btn-main-2 btn-icon btn-round-full"
                                                                                        onClick={(e) =>
                                                                                            fnBnDeleteClick(
                                                                                                i,
                                                                                                banner.bn_serial,
                                                                                                e
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        삭제
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CSSTransition>
                                                    );
                                                })}
                                            </TransitionGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SubMenu id="admin" />
                    </div>
                </div>
            </section>
        </>
    );
}

export default BannerMgr;
